(function () {
  // Chiudi i menu quando clicchi fuori
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.vcdd__trigger');
    const dropdown = e.target.closest('.vcdd');
    const item = e.target.closest('.vcdd__item');

    // Toggle apertura
    if (trigger) {
      const dd = trigger.closest('.selector-wrapper').querySelector('.vcdd');
      const list = dd.querySelector('.vcdd__list');
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      list.hidden = expanded;
      if (!expanded) list.focus();
      return;
    }

    // Clic esterno: chiudi
    document.querySelectorAll('.vcdd').forEach(dd => {
      if (!dd.contains(e.target)) {
        const t = dd.querySelector('.vcdd__trigger');
        const l = dd.querySelector('.vcdd__list');
        if (t && l && t.getAttribute('aria-expanded') === 'true') {
          t.setAttribute('aria-expanded', 'false');
          l.hidden = true;
        }
      }
    });

    // Selezione voce
    if (item && dropdown) {
      if (item.classList.contains('is-disabled')) return; // rispetta disabled
      const value = item.getAttribute('data-value');
      const hiddenSelect = dropdown.querySelector('.vcdd__select');
      const triggerBtn = dropdown.querySelector('.vcdd__trigger');
      const list = dropdown.querySelector('.vcdd__list');

      // Aggiorna UI
      dropdown.querySelectorAll('.vcdd__item').forEach(li => {
        li.classList.toggle('is-active', li === item);
        li.setAttribute('aria-selected', li === item ? 'true' : 'false');
      });
      dropdown.querySelector('.vcdd__text').textContent = value;
      dropdown.querySelector('.vcdd__dot').setAttribute('data-value', value);

      // Aggiorna select nativo + evento change (fondamentale per il tema)
      hiddenSelect.value = value;
      hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));

      // Chiudi
      triggerBtn.setAttribute('aria-expanded', 'false');
      list.hidden = true;
    }
  });

  // ESC per chiudere
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.vcdd__list').forEach(list => {
        const trigger = list.closest('.vcdd').querySelector('.vcdd__trigger');
        trigger.setAttribute('aria-expanded', 'false');
        list.hidden = true;
        trigger.focus();
      });
    }
  });

  // Sincronizza disabled/selected dallo <select> nascosto verso la lista (utile se il tema disabilita opzioni)
  function syncFromSelect(select) {
    const dd = select.closest('.selector-wrapper').querySelector('.vcdd');
    if (!dd) return;
    const current = select.value;
    dd.querySelector('.vcdd__text').textContent = current;
    dd.querySelector('.vcdd__dot').setAttribute('data-value', current);

    // Update selected + disabled
    const options = Array.from(select.options);
    dd.querySelectorAll('.vcdd__item').forEach(li => {
      const v = li.getAttribute('data-value');
      const opt = options.find(o => o.value === v);
      const isSelected = v === current;
      li.classList.toggle('is-active', isSelected);
      li.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      const disabled = !!(opt && opt.disabled);
      li.classList.toggle('is-disabled', disabled);
      li.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  // Al change del select nascosto (o se il tema ricalcola gli stati), riallinea la UI
  document.addEventListener('change', function (e) {
    const sel = e.target.closest('.vcdd__select');
    if (sel) syncFromSelect(sel);
  });

  // Inizializzazione
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.vcdd__select').forEach(syncFromSelect);
  });
})();